import React, { useEffect, useRef } from 'react';
import { profile } from '../mock';

export default function BatmanSection() {
  const wrapRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      if (!imgRef.current || !wrapRef.current) return;
      const r = wrapRef.current.getBoundingClientRect();
      const progress = 1 - r.top / window.innerHeight;
      const y = Math.max(-30, Math.min(30, progress * 40 - 20));
      imgRef.current.style.transform = `translateY(${y}px) scale(1.05)`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section
      id="batman"
      className="section"
      style={{ paddingTop: 120, paddingBottom: 120 }}
    >
      <div className="section-label reveal" style={{ marginBottom: 28 }}>
        03 &mdash; Alter ego
      </div>

      <div className="twocol"
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1.2fr) minmax(0, 1fr)',
          gap: 56,
          alignItems: 'center',
        }}
      >
        <div ref={wrapRef} className="batman-frame reveal" style={{ aspectRatio: '1 / 1', maxHeight: 620 }}>
          <img ref={imgRef} src={profile.batmanImage} alt="Shadow of Likith" />
          <div
            className="mono"
            style={{
              position: 'absolute',
              right: 20,
              top: 20,
              fontSize: 10,
              letterSpacing: '0.35em',
              color: 'rgba(245,245,245,0.55)',
              padding: '6px 10px',
              border: '1px solid rgba(245,245,245,0.2)',
              borderRadius: 999,
              zIndex: 2,
              background: 'rgba(0,0,0,0.35)',
              backdropFilter: 'blur(6px)',
            }}
          >
            CLASSIFIED
          </div>
        </div>

        <div className="reveal">
          <h2
            className="section-title"
            style={{ margin: 0, maxWidth: 560 }}
          >
            Work in the<br />shadows.<br />
            <span style={{ color: 'rgba(245,245,245,0.4)' }}>Deliver in the light.</span>
          </h2>

          <p
            style={{
              marginTop: 28,
              color: 'rgba(245,245,245,0.7)',
              fontSize: 16,
              lineHeight: 1.7,
              maxWidth: 520,
            }}
          >
            Quiet, sharp, obsessive about detail. I treat every project like a mission &mdash;
            scope it, stalk the references, and ship it clean. No noise, no fluff, just
            work that cuts through.
          </p>

          <div
            style={{
              marginTop: 36,
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 20,
              maxWidth: 520,
            }}
          >
            {[
              { n: '120+', l: 'Projects' },
              { n: '48h', l: 'Avg delivery' },
              { n: '99%', l: 'Happy clients' },
            ].map((s) => (
              <div
                key={s.l}
                style={{
                  padding: '18px 16px',
                  border: '1px solid rgba(245,245,245,0.08)',
                  borderRadius: 10,
                  background: 'rgba(10,10,10,0.4)',
                }}
              >
                <div
                  style={{
                    fontFamily: 'Space Grotesk, sans-serif',
                    fontSize: 28,
                    fontWeight: 600,
                    color: '#f5f5f5',
                  }}
                >
                  {s.n}
                </div>
                <div
                  className="mono"
                  style={{
                    fontSize: 10,
                    letterSpacing: '0.3em',
                    color: 'rgba(245,245,245,0.5)',
                    textTransform: 'uppercase',
                    marginTop: 6,
                  }}
                >
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
